// =================================================================================================
// ===================================== AUTH ======================================================
// =================================================================================================
export const LOGIN_PAGE = "/auth/login";
export const SIGNUP_PAGE = "/auth/signup";
export const RESET_PASSWORD_PAGE = "/auth/reset-password/:id";
export const FORGOT_PASSWORD_PAGE = "/auth/forgot-password";
